import fetch from '../utils/fetch'

export function getCommunityDetail (id) {
  return fetch({
    url: '/community/' + id,
    method: 'get'
  })
}

export function communityCreate (query) {
  return fetch({
    url: '/community',
    method: 'post',
    params: query
  })
}

export function communityUpdate (id, query) {
  return fetch({
    url: '/community/' + id,
    method: 'put',
    params: query
  })
}

export function communityDelete (id) {
  return fetch({
    url: '/community/' + id,
    method: 'delete'
  })
}

export function getCommunityList (query) {
  return fetch({
    url: '/community',
    method: 'get',
    params: query
  })
}

export function CommunityStatusUpdate (query) {
  return fetch({
    url: '/communitys/updateStatus',
    method: 'put',
    params: query
  })
}

export function CommunityActivityCreate (query) {
  return fetch({
    url: '/promotions/community/activity',
    method: 'post',
    params: query,
    refreshToken: true
  })
}

export function CommunityActivityList (query) {
  return fetch({
    url: '/promotions/community/activity',
    method: 'get',
    params: query
  })
}

export function CommunityActivityInfo (id, query) {
  return fetch({
    url: '/promotions/community/activity/' + id,
    method: 'get',
    params: query
  })
}

export function CommunityActivityStatusUpdate (query) {
  return fetch({
    url: '/promotions/community/activitys/updatestatus',
    method: 'put',
    params: query
  })
}

export function communityActivityItemList (id, query) {
  return fetch({
    url: '/promotions/community/activityItemList/' + id,
    method: 'get',
    params: query
  })
}

export function getDeliveryOrderList (query) {
  return fetch({
    url: '/promotions/community/deliveryorder',
    method: 'get',
    params: query
  })
}

export function getDeliveryOrderDetail (deliveryid) {
  return fetch({
    url: '/promotions/community/deliveryorder/' + deliveryid,
    method: 'get'
  })
}

export function shippingDeliveryorder (query) {
  return fetch({
    url: '/promotions/community/deliveryorder',
    method: 'put',
    params: query
  })
}

export function batchShippingDeliveryorder (query) {
  return fetch({
    url: '/promotions/community/batchdeliveryorder',
    method: 'put',
    params: query
  })
}
export function CommunityActivityUpdate (id, query) {
  return fetch({
    url: '/promotions/community/activity/' + id,
    method: 'put',
    params: query,
    refreshToken: true
  })
}
export function setDeliveryorderMemo (query) {
  return fetch({
    url: '/promotions/community/deliveryordermemo',
    method: 'put',
    params: query
  })
}

export function exportDeliveryorder (query) {
  return fetch({
    url: '/promotions/community/deliveryorderexport',
    method: 'get',
    params: query
  })
}

export function exportDeliveryorderInfo (query) {
  return fetch({
    url: '/promotions/community/deliveryorderinfo/export',
    method: 'get',
    params: query
  })
}

export function exportActivityItemList (query) {
  return fetch({
    url: '/promotions/community/activityGoodsExport',
    method: 'get',
    params: query
  })
}

export function getCommunityPointList (query) {
  return fetch({
    url: '/promotions/community/point',
    method: 'get',
    params: query
  })
}

export function changeCommunityPoint (query) {
  return fetch({
    url: '/promotions/community/point',
    method: 'post',
    params: query
  })
}

export function processCashWithdrawal (cash_withdrawal_id, query) {
  return fetch({
    url: '/promotions/community/cash_withdrawals/' + cash_withdrawal_id,
    method: 'put',
    params: query
  })
}

export function getCashWithdrawalList (query) {
  return fetch({
    url: '/promotions/community/cashWithdrawals',
    method: 'get',
    params: query
  })
}

export function getMerchantTradeList (cash_withdrawal_id, query) {
  return fetch({
    url: '/promotions/community/cashWithdrawal/payinfo/' + cash_withdrawal_id,
    method: 'get',
    params: query
  })
}

export function withdrawExport (query) {
  return fetch({
    url: '/promotions/community/cashWithdrawals/export/',
    method: 'get',
    params: query
  })
}

export function batchProcessCashWithdrawal (query) {
  return fetch({
    url: '/community/cashWithdrawal/batchpayinfo',
    method: 'put',
    params: query
  })
}

export function getCommunityOrderList (query) {
  return fetch({
    url: '/community/orders',
    method: 'get',
    params: query
  })
}

export function getCommunityOrderDetail (orderId) {
  return fetch({
    url: '/community/order/' + orderId,
    method: 'get'
  })
}

// 新增活動商品
export function addActivityGoods (params) {
  return fetch({
    url: `/community/items`,
    method: 'post',
    params
  })
}

// 獲取社區拚團商品列表
export function getActivityGoods (params) {
  return fetch({
    url: `/community/items`,
    method: 'get',
    params
  })
}

// 刪除商品
export function deleteActivityGoods (id) {
  return fetch({
    url: `/community/item/${id}`,
    method: 'delete'
  })
}

// 修改商品起送量
export function modifyGoodsDeliverNum (params) {
  return fetch({
    url: `/community/itemMinDeliveryNum`,
    method: 'post',
    params
  })
}

// 修改商品排序編號
export function modifyGoodsSort (params) {
  return fetch({
    url: `/community/itemSort`,
    method: 'post',
    params
  })
}

// 儲存社區團購設置
export function modifyActivitySetting (params) {
  return fetch({
    url: `/community/activity/setting`,
    method: 'post',
    params
  })
}

// 獲取社區團購設置
export function getActivitySetting (params) {
  return fetch({
    url: `/community/activity/setting`,
    method: 'get',
    params
  })
}

// 配置字段列表
export function getCommunityChiefApplyFields (params) {
  return fetch({
    url: `/community/chief/apply_fields`,
    method: 'get',
    params
  })
}

// 創建字段
export function createCommunityChiefApplyFields (params) {
  return fetch({
    url: `/community/chief/apply_field`,
    method: 'post',
    params
  })
}

// 更新字段的開關
export function modifyFieldSwitch (id, params) {
  return fetch({
    url: `/community/chief/apply_field/switch/${id}`,
    method: 'post',
    params
  })
}

// 刪除字段
export function deleteCommunityField (id) {
  return fetch({
    url: `/community/chief/apply_field/${id}`,
    method: 'delete'
  })
}

// 更新字段的內容
export function modifyCommunityField (params) {
  const { id } = params
  return fetch({
    url: `/community/chief/apply_field/${id}`,
    method: 'post',
    params
  })
}

// 團長申請列表
export function getChiefList (params) {
  return fetch({
    url: `/community/chief/apply/list`,
    method: 'get',
    params
  })
}

// 團長申請詳情
export function getChiefDetail (id) {
  return fetch({
    url: `/community/chief/apply/info/${id}`,
    method: 'get'
  })
}

// 團長申請審批
export function approveChief (apply_id, params) {
  return fetch({
    url: `/community/chief/approve/${apply_id}`,
    method: 'post',
    params
  })
}

// 獲取小程序碼
export function getChiefWxCode (params) {
  return fetch({
    url: `/community/chief/apply/wxaCode`,
    method: 'get',
    params
  })
}

//
export function withdrawApply (id, params) {
  return fetch({
    url: `/community/cash_withdrawal/${id}`,
    method: 'post',
    params
  })
}

// 提現傭金支付訊息
export function getPayInfo (id) {
  return fetch({
    url: `/community/cash_withdrawal/payinfo/${id}`,
    method: 'get'
  })
}
